export const replaceLinkByTag = (content: string) => {
  const expMatch = /(\b(https?|):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  const elementContent = content.replace(expMatch, '<a target="_blank" href="$1">$1</a>');
  const newExpMatch = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  return elementContent.replace(newExpMatch, '$1<a target="_blank" href="http://$2">$2</a>');
};
